export const loginPath = type => type === 'platform' ? '/platform-admin/login' : '/login';
export const defaultPath = type => type === 'platform' ? '/platform-admin' : '/app/tools';

// Only application pathnames, never origins, credentials, query strings or URL fragments.
export function safeReturnTo(value, type = 'tenant') {
  if (typeof value !== 'string' || /[\\?#%]/.test(value) || [...value].some(c => c.charCodeAt(0) < 32) || value.startsWith('//')) return defaultPath(type);
  const allowed = type === 'platform' ? /^\/platform-admin(?:\/|$)/ : /^\/app\/(tools|admin)(?:\/|$)/;
  if (!allowed.test(value) || value === '/platform-admin/login' || value.split('/').some(p => p === '..' || p === '.')) return defaultPath(type);
  return value;
}

const SSO_DESTINATION = 'cobygo.sso.destination';
export function rememberSsoDestination(path) {
  // Route metadata only; no authentication material is stored here.
  try { sessionStorage.setItem(SSO_DESTINATION, safeReturnTo(path)); } catch { /* Private browsing may disable route persistence. */ }
}
export function takeSsoDestination() {
  try {
    const value = sessionStorage.getItem(SSO_DESTINATION);
    sessionStorage.removeItem(SSO_DESTINATION);
    return value ? safeReturnTo(value) : null;
  } catch { return null; }
}
